<template>
  <div id="item-detail-page">
    <vx-card :key="productId" :cardBorder="true" class="my-2" v-if="product">
      <template slot="no-body">
        <!-- Item Main Info -->
        <div class="w-full p-4">
          <div class="w-full p-2 mb-2">
            <div class="text-2xl text-left text-primary">
              {{ product.code }} - {{ productLang.name }}
            </div>
          </div>

          <div class="w-full flex flex-wrap">
            <!-- Col left (image) -->
            <div class="w-full md:w-1/3 flex flex-col px-2">
              <div class="w-full flex justify-center md:justify-start">
                <img :src="product.image" :alt="productLang.name" class="max-w-xs responsive">
              </div>
              <div class="w-full flex my-2">
                <div class="flex flex-wrap items-center">
                  <vs-button class="mr-4" type="border" icon-pack="feather" color="#c4302b" icon="icon-youtube" radius> </vs-button>
                </div>
              </div>
            </div>

            <!-- Col rigth (content) -->
            <div class="w-full md:w-2/3 px-2 md:px-4">
              <div class="w-full">
                <h5 class="text-2xl leading-none font-medium text-primary mr-4 mt-2" v-if="$store.state.Profile.isBRL()">
                  {{ product.price | BRL }}
                </h5>
                <h5 class="text-2xl leading-none font-medium text-primary mr-4 mt-2" v-else>
                  {{ product.price | USD }}
                </h5>
              </div>

              <div class="w-full">
                <span class="text-sm">
                  {{ $t('pages.products.productQtd') }} {{ $t(`lists.productOptionQtd.${product.qtdOption}`) }}
                </span>
              </div>

              <div class="border-solid border-2 border-primary my-4 p-2">
                <div class="text-sm mb-2">
                  {{ $t('pages.products.lang.description') }}
                </div>

                <div class="text-black flex text-justify">
                  {{ productLang.description }}
                </div>
              </div>

              <vs-list class="product-sales-meta-list px-0 pt-4">
                <vs-list-item class="p-0 border-none" icon-pack="feather" icon="icon-clock" v-if="product.manufactureTime > 0"
                              :title="manufacture_format"/>

                <vs-list-item v-if="product.isServicePlanning()" class="p-0 border-none" icon-pack="feather" icon="icon-image"
                              :title="$t('pages.shop.detailItem.mockup')"/>

                <div v-if="product.innerProducts.length">
                  <h3 class="w-full flex justify-center font-bold text-lg text-secondary-t">
                    {{ $t('pages.shop.detailItem.sectionManufacture.title') }}
                  </h3>
                  <shop-item-preview v-for="item in product.innerProducts" :key="item" :product-id="item" />
                </div>

                <vs-list-item v-if="product.isServiceManufacture()" class="p-0 border-none" icon-pack="feather" icon="icon-printer"
                              :title="$t('pages.shop.detailItem.print')"/>
              </vs-list>
            </div>
          </div>
        </div>
      </template>
    </vx-card>
  </div>
</template>

<script>
//import { videoPlayer } from 'vue-video-player'
import 'video.js/dist/video-js.css'
import ShopItemPreview from "@/views/ecommerce/ShopItemPreview";
//TODO https://www.fabiofranchino.com/blog/inject-svg-in-dom-with-vue/
// import MySVG from '@/assets/scss/customIcons/icons/tooth.svg?inline'

export default {
  components: {
    ShopItemPreview
    // MySVG
    //videoPlayer
  },
  props: {
    productId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {

    }
  },
  computed: {
    productLang() {
      const locale = this.$i18n.locale;
      return this.product[locale];
    },
    product() {
      return this.$store.getters['Shop/getProductByIdFromShop'](this.productId);
    },
    calcDiscount() {
      if (this.product.discount > 0) {
        return (this.product.price * this.product.discount / 100);
      }
      return 0;
    },
    calcTotal() {
      return this.product.price - this.calcDiscount;
    },
    isInCart () {
      return (itemId) => this.$store.getters['Shop/isInCart'](itemId);
    },
    manufacture_format() {
      return this.$t('pages.shop.detailItem.manufactureTime', { manufacture_time: this.product.manufactureTime });
    }
  },
  methods: {
    toggleItemInCart (item) {
      this.$store.dispatch('Shop/toggleItemInCart', item.id);
    },
  },
  created () {
    console.log('DEBUG => CREATEING ECOMMERCE DETAIL VIEW ITEM = ', this.productId);
  },
}
</script>

<style lang="scss">
//@import 'src/assets/scss/customIcons/dental-icon.scss';
#item-detail-page {
  .color-radio {
    height: 2.28rem;
    width: 2.28rem;

    > div {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .item-features {
    background-color: #f7f7f7;

    .theme-dark & {
      background-color: $theme-dark-secondary-bg;
    }
  }

  .product-sales-meta-list {
    .vs-list--icon {
      padding-left: 0;
    }
  }

  .related-product-swiper {
      // padding-right: 2rem;
      // padding-left: 2rem;

    .swiper-wrapper {
      padding-bottom: 2rem;

      > .swiper-slide {
        background-color: #f7f7f7;
        box-shadow: 0 4px 18px 0 rgba(0,0,0,0.1), 0 5px 12px 0 rgba(0,0,0,0.08) !important;

        .theme-dark & {
          background-color: $theme-light-dark-bg;
        }
      }
    }

    .swiper-button-next,
    .swiper-button-prev {
      transform: scale(.5);
      filter: hue-rotate(40deg);
    }

    .swiper-button-next {
      right: 0
    }

    .swiper-button-prev {
      left: 0;
    }
  }
}
</style>
